import { Link } from 'react-router-dom'

interface TagPillProps {
  label: string
  linkTo?: string
  variant?: 'default' | 'archive' | 'theme' | 'region' | 'type'
  size?: 'sm' | 'md'
}

const variantStyles: Record<string, string> = {
  default: 'bg-archive-stone/50 text-archive-muted border-archive-ash/30',
  archive: 'bg-archive-gold/10 text-archive-gold border-archive-gold/30',
  theme: 'bg-purple-900/30 text-purple-300 border-purple-500/30',
  region: 'bg-emerald-900/30 text-emerald-300 border-emerald-500/30',
  type: 'bg-blue-900/30 text-blue-300 border-blue-500/30',
}

export default function TagPill({
  label,
  linkTo,
  variant = 'default',
  size = 'sm',
}: TagPillProps) {
  const baseClasses = `inline-flex items-center font-medium uppercase tracking-wider border rounded transition-colors duration-200 ${variantStyles[variant]}`
  const sizeClasses = size === 'sm' ? 'px-2 py-0.5 text-[10px]' : 'px-2.5 py-1 text-xs'

  if (linkTo) {
    return (
      <Link
        to={linkTo}
        className={`${baseClasses} ${sizeClasses} hover:bg-archive-stone hover:text-archive-text`}
      >
        {label}
      </Link>
    )
  }

  return (
    <span className={`${baseClasses} ${sizeClasses}`}>
      {label}
    </span>
  )
}
